import { SEO } from './components/SEO'
import { LandingPage } from './components/LandingPage'
import { ShareCard } from './components/ShareCard'
import { LegalPage } from './components/LegalPage'

function App() {
  const mode = import.meta.env.VITE_MODE || 'waitlist'
  const appName = 'Co-Palms'
  const appDescription =
    "Your hand already knows what's next. Get a precise palm reading for the week ahead."
  const appUrl = import.meta.env.VITE_APP_URL || 'https://co-palms.altuzar.dev'
  const ogImage = import.meta.env.VITE_OG_IMAGE || `${appUrl}/og-image.png`

  // Zero-click share landing: /c/<token> renders a public comparison card.
  const path = typeof window !== 'undefined' ? window.location.pathname : '/'
  const shareMatch = path.match(/^\/c\/([^/?#]+)/)

  if (path === '/privacy' || path === '/legal') {
    const page = path.slice(1) as 'privacy' | 'legal'
    return <LegalPage page={page} appName={appName} appUrl={appUrl} />
  }

  if (shareMatch) {
    return (
      <>
        <SEO
          title={`${appName} — Compatibility reading`}
          description="See this Co-Palms compatibility reading — then read your own palm."
          image={ogImage}
          url={`${appUrl}${path}`}
        />
        <ShareCard token={decodeURIComponent(shareMatch[1])} />
      </>
    )
  }

  return (
    <>
      <SEO title={appName} description={appDescription} image={ogImage} url={appUrl} />
      <LandingPage mode={mode === 'launch' ? 'launch' : 'waitlist'} />
    </>
  )
}

export default App
